import styles from "@/styles/productDetail/detailRecommend.module.scss"
import productApi from '@/service/modules/productApi'
import GoodsComponent from "../GoodsComponent"
import { useEffect, useState } from "react"

interface Props {
  productID: number | undefined;
}

export default function DetailRecommend({ productID }: Props) {
  useEffect(() => {
    function handleWindowLoad() {
      getSimilar()
    }
    
    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  const [goodsList, setGoodsList] = useState([])
  const getSimilar = async () => {
    try {
      let res = await productApi.getSimilar({ productID: productID })
      if (res.data) {
        setGoodsList(res.data.products)
      }
    } catch (error: any) {
      console.error(error)
    }
  }
  return (
    <div className={styles['detailRecommend']} id="product-recommend">
      <h1 className={styles['title']}>Recommend for you</h1>
      <div className={styles['goods-list']}>
        {
          goodsList.map((item: any, index: number) => {
            const goodsInfo = {
              ...item,
              productName: item.name,
              imgUrl: item.newSmallPicture
            }
            return (
              <div className={styles['goodsItem']} key={index}>
                <GoodsComponent {...goodsInfo} position={index} location="homepage_recommend" type='Recommend' />
              </div>
            )
          })
        }
        <div className={styles['goodsItem']} style={{ marginBottom: "0" }}></div>
        <div className={styles['goodsItem']} style={{ marginBottom: "0" }}></div>
        <div className={styles['goodsItem']} style={{ marginBottom: "0" }}></div>
        <div className={styles['goodsItem']} style={{ marginBottom: "0" }}></div>
        {/* {
          [...new Array(goodsList.length % 5 != 0 ? 5 - goodsList.length % 5 : 0)].map((v, i) => (
            <div className={styles['goodsItem']} key={i} ></div>
          ))
        } */}

      </div>
    </div>
  )
}